<template>
  <div class="content_box">
    <div class="content_box_inner">
      <el-row style="margin-top: 10px">
        <el-col
          :xs="24"
          :lg="4"
          v-for="(item, index) in List"
          :key="index"
          style="
            background: #fff;
            margin-right: 20px;
            margin-bottom: 10px;
            padding: 10px 20px;
            box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.2);
          "
        >
          <div style="font-size: 16px; color: #83d7f7">{{ item.name }}</div>
          <div style="font-size: 12px; color: #333; margin: 3px 0">
            <span
              style="
                display: inline-block;
                height: 10px;
                width: 10px;
                background: #ff7f00;
              "
            ></span>
            橙色预警
            <span style="display: inline-block; width: 20px; margin: 0 2px">{{
              item.orange
            }}</span>
            个
          </div>
          <div style="font-size: 12px; color: #333; margin: 3px 0">
            <span
              style="
                display: inline-block;
                height: 10px;
                width: 10px;
                background: #ffd700;
              "
            ></span>
            黄色预警
            <span style="display: inline-block; width: 20px; margin: 0 2px">{{
              item.yellow
            }}</span>
            个
          </div>
          <div style="font-size: 12px; color: #333; margin: 3px 0">
            <span
              style="
                display: inline-block;
                height: 10px;
                width: 10px;
                background: #f00;
              "
            ></span>
            红色预警
            <span style="display: inline-block; width: 20px; margin: 0 2px">{{
              item.red
            }}</span>
            个
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-tabs style="margin-top: 10px" v-model="activeName">
          <el-tab-pane label="生产经营监测" name="capitalChain">
            <capitalChain
              v-if="activeName === 'capitalChain'"
              v-on:getData="showData"
            ></capitalChain>
          </el-tab-pane>
          <el-tab-pane label="企业资金链" name="production">
            <production
              v-if="activeName === 'production'"
              v-on:getData="showData"
            ></production>
          </el-tab-pane>
        </el-tabs>
      </el-row>
    </div>
  </div>
</template>

<script>
import capitalChain from "./capitalChain";
import production from "./production";
export default {
  components: {
    capitalChain,
    production,
  },
  data() {
    return {
      activeName: "capitalChain",
      List: [],
    };
  },
  methods: {
    showData(data) {
      this.$axios
        .get(
          `/business/upgrade/risk/selectAllRisk?dateRange=${data.time}&district=${data.district}&industryName=${data.industryName}&companyName=${data.companyName}`
        )
        .then((res) => {
          this.List = res.data.data;
        });
    },
  },
  created() {},
};
</script>
<style>
@import url("../../../assets/styles/elementUI.css");
</style>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
}
</style>